/* =============================================
   STICKY ADD TO CART — VitaDoza / Root Theme
   v5.7 — cart state sync + bfcache drawer reset
   ============================================= */

(function () {
  'use strict';

  const BAR_ID = 'sticky-atc-bar';
  const BRAND_COLOR = '#012A06';
  const CART_URL = window.Shopify.routes.root + 'cart.js';
  const CART_ADD_URL = window.Shopify.routes.root + 'cart/add.js';
  const CART_PAGE_URL = window.Shopify.routes.root + 'cart';

  function debounce(fn, delay) {
    var timer;

    return function () {
      var args = arguments;

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function initStickyATC() {
    var bar = document.getElementById(BAR_ID);
    if (!bar) return;

    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    var productForm = document.querySelector('product-form');
    if (!productForm) return;

    var originalSubmitBtn = productForm.querySelector('[type="submit"]');
    if (!originalSubmitBtn) return;

    var form = productForm.querySelector('form');
    if (!form) return;

    var stickyBtn = bar.querySelector('.sticky-atc__btn');
    var stickyQtyInput = bar.querySelector('.sticky-atc__qty-input');
    var qtyMinus = bar.querySelector('.sticky-atc__qty-btn--minus');
    var qtyPlus = bar.querySelector('.sticky-atc__qty-btn--plus');
    var qtyEl = bar.querySelector('.sticky-atc__quantity');

    if (!stickyBtn || !stickyQtyInput || !qtyMinus || !qtyPlus) return;

    var quantity = 1;
    var hasScrolled = false;
    var isInCart = false;
    var isSyncing = false;

    var mainQtyInput = form.querySelector('[name="quantity"]');

    function isDesktop() {
      return window.innerWidth >= 750;
    }

    function normalizeQty(value) {
      return Math.max(1, parseInt(value, 10) || 1);
    }

    function updateStickyQty(value) {
      quantity = normalizeQty(value);
      stickyQtyInput.value = quantity;
    }

    function updateMainQty(value) {
      if (!mainQtyInput || isSyncing) return;

      isSyncing = true;

      mainQtyInput.value = normalizeQty(value);

      mainQtyInput.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      mainQtyInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );

      isSyncing = false;
    }

    window.addEventListener(
      'scroll',
      function onFirstScroll() {
        hasScrolled = true;
        window.removeEventListener('scroll', onFirstScroll);
      },
      { passive: true }
    );

    function getVariantId() {
      var variantInput = form.querySelector('[name="id"]');
      return variantInput ? variantInput.value : null;
    }

    function setGoToCartMode() {
      isInCart = true;

      stickyBtn.textContent = 'Sepete Git →';
      stickyBtn.style.background = BRAND_COLOR;
      stickyBtn.disabled = false;
      stickyBtn.style.flex = '1';
      stickyBtn.style.maxWidth = isDesktop() ? '28rem' : '';

      if (qtyEl) {
        qtyEl.style.display = 'none';
      }
    }

    function setAddToCartMode() {
      isInCart = false;

      stickyBtn.textContent =
        stickyBtn.dataset.label || 'Sepete Ekle';

      stickyBtn.style.background = '';
      stickyBtn.style.flex = '';
      stickyBtn.style.maxWidth = '';
      stickyBtn.disabled = originalSubmitBtn.disabled;

      if (qtyEl) {
        qtyEl.style.display = '';
      }
    }

    function setSoldOutMode() {
      isInCart = false;

      stickyBtn.textContent = 'Tükendi';
      stickyBtn.style.background = '';
      stickyBtn.style.flex = '1';
      stickyBtn.style.maxWidth = isDesktop() ? '28rem' : '';
      stickyBtn.disabled = true;

      if (qtyEl) {
        qtyEl.style.display = 'none';
      }
    }

    function refreshAndOpenCartDrawer() {
      var cartDrawer = document.querySelector('cart-drawer');

      if (
        !cartDrawer ||
        typeof cartDrawer.getSectionsToRender !== 'function' ||
        typeof cartDrawer.renderContents !== 'function'
      ) {
        document.dispatchEvent(
          new CustomEvent('cart-drawer:refresh', {
            bubbles: true
          })
        );

        return Promise.resolve();
      }

      var sectionsToRender = cartDrawer.getSectionsToRender();

      if (!sectionsToRender || !sectionsToRender.length) {
        return Promise.resolve();
      }

      var sectionIds = sectionsToRender
        .map(function (section) {
          return section.id;
        })
        .join(',');

      cartDrawer.openerEl = stickyBtn;

      return fetch(
        window.Shopify.routes.root +
          '?sections=' +
          encodeURIComponent(sectionIds),
        {
          cache: 'no-store',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart drawer refresh failed');
          }

          return response.json();
        })
        .then(function (sections) {
          var shouldOpen = !cartDrawer.isOpen;

          cartDrawer.renderContents(
            {
              sections: sections
            },
            shouldOpen
          );
        })
        .catch(function (error) {
          console.error(
            'Sticky ATC cart drawer error:',
            error
          );

          document.dispatchEvent(
            new CustomEvent('cart-drawer:refresh', {
              bubbles: true
            })
          );
        });
    }

    function refreshCartDrawerClosed() {
      var cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        return;
      }

      /*
       * bfcache eski açık drawer state'ini geri getirebilir.
       * Drawer'ı doğrudan kapalı state'e getiriyoruz.
       */
      cartDrawer.removeAttribute('open');
      cartDrawer.isOpen = false;

      if (
        cartDrawer.drawer &&
        cartDrawer.classDrawerActive
      ) {
        cartDrawer.drawer.classList.remove(
          cartDrawer.classDrawerActive
        );
      }

      if (cartDrawer.activeOverlayBodyClass) {
        document.body.classList.remove(
          cartDrawer.activeOverlayBodyClass
        );
      }

      /*
       * Drawer'ın erişilebilirlik/tabindex state'ini de kapalı hale getir.
       */
      if (
        typeof cartDrawer.toggleEelements === 'function' &&
        typeof setTabindex === 'function'
      ) {
        setTabindex(
          cartDrawer.toggleEelements(),
          '-1'
        );
      }

      /*
       * Drawer içeriğini gerçek sepetle yenile.
       * Drawer açılmaz.
       */
      document.dispatchEvent(
        new CustomEvent('cart-drawer:refresh', {
          bubbles: true
        })
      );
    }

    var checkCart = debounce(function () {
      var variantId = getVariantId();

      if (!variantId) return;

      if (originalSubmitBtn.disabled) {
        setSoldOutMode();
        return;
      }

      fetch(CART_URL, {
        cache: 'no-store',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('Cart check failed');
          }

          return res.json();
        })
        .then(function (cart) {
          var inCart = cart.items.some(function (item) {
            return String(item.variant_id) === String(variantId);
          });

          if (inCart) {
            setGoToCartMode();
          } else {
            setAddToCartMode();
          }
        })
        .catch(function () {
          if (!isInCart) {
            stickyBtn.disabled = originalSubmitBtn.disabled;
          }
        });
    }, 300);

    var variantInput = form.querySelector('[name="id"]');

    if (variantInput) {
      variantInput.addEventListener('change', checkCart);
      variantInput.addEventListener('input', checkCart);

      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(checkCart).observe(
          variantInput,
          {
            attributes: true,
            attributeFilter: ['value']
          }
        );
      }
    }

    document.addEventListener('variant:changed', checkCart);

    var cartDrawer = document.querySelector('cart-drawer');

    if (
      cartDrawer &&
      typeof MutationObserver !== 'undefined'
    ) {
      new MutationObserver(
        debounce(function () {
          checkCart();
        }, 150)
      ).observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener(
      'cart-drawer:refresh',
      checkCart
    );

    document.addEventListener(
      'cart:refresh',
      checkCart
    );

    checkCart();

    /*
     * Browser geri / ileri navigasyonu.
     * Drawer state'ini resetle,
     * drawer içeriğini güncelle,
     * sticky state'ini tekrar doğrula.
     */
    window.addEventListener('pageshow', function () {
      refreshCartDrawerClosed();
      checkCart();
    });

    window.addEventListener(
      'resize',
      debounce(function () {
        if (isInCart) {
          stickyBtn.style.maxWidth =
            isDesktop() ? '28rem' : '';
        }
      }, 200)
    );

    if (mainQtyInput) {
      updateStickyQty(mainQtyInput.value);

      mainQtyInput.addEventListener(
        'input',
        function () {
          if (isSyncing) return;

          updateStickyQty(mainQtyInput.value);
        }
      );

      mainQtyInput.addEventListener(
        'change',
        function () {
          if (isSyncing) return;

          updateStickyQty(mainQtyInput.value);
        }
      );
    } else {
      stickyQtyInput.value = quantity;
    }

    qtyMinus.addEventListener(
      'click',
      function () {
        if (quantity > 1) {
          quantity--;

          stickyQtyInput.value = quantity;
          updateMainQty(quantity);
        }
      }
    );

    qtyPlus.addEventListener(
      'click',
      function () {
        quantity++;

        stickyQtyInput.value = quantity;
        updateMainQty(quantity);
      }
    );

    stickyQtyInput.addEventListener(
      'input',
      function () {
        updateStickyQty(stickyQtyInput.value);
        updateMainQty(quantity);
      }
    );

    stickyQtyInput.addEventListener(
      'change',
      function () {
        updateStickyQty(stickyQtyInput.value);
        updateMainQty(quantity);
      }
    );

    stickyBtn.addEventListener(
      'click',
      function () {
        if (
          stickyBtn.disabled ||
          stickyBtn.classList.contains('loading')
        ) {
          return;
        }

        if (isInCart) {
          window.location.href = CART_PAGE_URL;
          return;
        }

        if (originalSubmitBtn.disabled) return;

        var variantId = getVariantId();
        if (!variantId) return;

        quantity = normalizeQty(stickyQtyInput.value);

        stickyBtn.classList.add('loading');
        stickyBtn.textContent = '...';

        fetch(CART_ADD_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
          .then(function (res) {
            if (!res.ok) {
              throw new Error('Cart add failed');
            }

            return res.json();
          })
          .then(function () {
            stickyBtn.classList.remove('loading');

            setGoToCartMode();

            return refreshAndOpenCartDrawer();
          })
          .catch(function () {
            stickyBtn.classList.remove('loading');
            stickyBtn.textContent = 'Hata!';

            setTimeout(function () {
              checkCart();
            }, 1500);
          });
      }
    );

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (isInCart) return;

        if (originalSubmitBtn.disabled) {
          setSoldOutMode();
        } else {
          checkCart();
        }
      }).observe(originalSubmitBtn, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    var sentinel =
      originalSubmitBtn.closest('.product-form') ||
      originalSubmitBtn;

    function showHideBar(isVisible) {
      if (!hasScrolled) return;

      if (isVisible) {
        bar.classList.remove('is-visible');
      } else {
        bar.classList.add('is-visible');
      }
    }

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            showHideBar(entry.isIntersecting);
          });
        },
        {
          threshold: 0
        }
      ).observe(sentinel);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          if (!hasScrolled) return;

          var rect = sentinel.getBoundingClientRect();

          showHideBar(
            rect.top < window.innerHeight &&
            rect.bottom > 0
          );
        },
        {
          passive: true
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initStickyATC
    );
  } else {
    initStickyATC();
  }
})();